/**
toType(object)
Returns `typeof object`.
*/

export default function toType(object) {
    return typeof object;
}
